<script setup>
defineProps({
  resident: {
    type: Object,
    required: true,
  },
});
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลติดต่อ</h5>
          <div class="text-muted small">ข้อมูลการติดต่อและผู้ติดต่อฉุกเฉิน</div>
        </div>
        <div class="contact-avatar">
          <i class="bi bi-person-lines-fill"></i>
        </div>
      </div>

      <div class="vstack gap-3 mb-4">
        <div class="info-row">
          <i class="bi bi-telephone text-primary"></i>
          <div>
            <div class="info-label">เบอร์โทรศัพท์</div>
            <div class="info-value">{{ resident.phone || "-" }}</div>
          </div>
        </div>

        <div class="info-row">
          <i class="bi bi-envelope text-primary"></i>
          <div>
            <div class="info-label">อีเมล</div>
            <div class="info-value">{{ resident.email || "-" }}</div>
          </div>
        </div>

        <div class="info-row">
          <i class="bi bi-geo-alt text-primary"></i>
          <div>
            <div class="info-label">ที่อยู่</div>
            <div class="info-value">{{ resident.address || "-" }}</div>
          </div>
        </div>
      </div>

      <div class="pt-3 border-top">
        <div class="fw-semibold mb-3">ผู้ติดต่อฉุกเฉิน</div>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <span class="text-muted">ชื่อผู้ติดต่อ</span>
          <span class="fw-semibold">{{
            resident.emergencyContact || "-"
          }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เบอร์โทร</span>
          <span class="fw-semibold">{{ resident.emergencyPhone || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.contact-avatar {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
.info-row {
  display: flex;
  gap: 0.9rem;
  align-items: flex-start;
}
.info-row i {
  font-size: 1.1rem;
  margin-top: 0.1rem;
}
.info-label {
  font-size: 0.82rem;
  color: #6c757d;
}
.info-value {
  font-weight: 600;
}
</style>
